import React, { Fragment, useEffect, useState } from 'react'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import { Box } from '@material-ui/core'
import LocationSearchingIcon from '@material-ui/icons/LocationSearching'
import TextField from '@material-ui/core/TextField'
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete'
import Card from '@auteco/components/sharedComponents/Card/Card'
import CardBody from '@auteco/components/sharedComponents/Card/CardBody'
import { getGDCParners } from '@auteco/services/gdcServices'
import { AccountTreeOutlined, MapOutlined } from '@material-ui/icons'
import PeopleIcon from '@material-ui/icons/People'
import useStyles from './styles'


const filter = createFilterOptions()

const GdcSearchBar = ({ selectOption, handleSelecterStep, reloadOptions }) => {
  const classes = useStyles()
  const [parner, setValue] = useState(selectOption)
  const [parnersList, setParnerlist] = React.useState([])

  const realoadParners = async () => {
    const { socios } = await getGDCParners()
    if (socios.length > 0) {
      setParnerlist(socios)
      if (selectOption) {
        setValue(socios.filter(item => item.razon_social === selectOption.razon_social)[0])
      }
      if (selectOption === null) {
        setValue(socios[0])
      }
    }
  }

  useEffect(() => {
    realoadParners()
  }, [reloadOptions])

  return (
    <section>
      <Paper className={classes.root}>
        <Box className={classes.iconButton} aria-label="menu">
          <LocationSearchingIcon />
        </Box>
        <Divider className={classes.divider} orientation="vertical" />
        <Autocomplete
          value={parner}
          className={classes.input}
          onChange={(event, newValue) => {
            if (typeof newValue === 'string') {
              setValue({
                title: newValue,
              })
            } else if (newValue && newValue.inputValue) {
              // Create a new value from the user input
              setValue({
                title: newValue.inputValue,
              })
            } else {
              setValue(newValue)
            }
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params)
            return filtered
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          id="frmo"
          options={parnersList}
          getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === 'string') {
              return option
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
              return option.inputValue
            }
            // Regular option
            return option.razon_social
          }}
          renderOption={(option) => option.razon_social}
          freeSolo
          renderInput={(params) => (
            <TextField
              {...params}
              label="Seleccione un socio"
              variant="outlined"
            />
          )}
        />
        <Divider className={classes.divider} orientation="vertical" />
      </Paper>
      <Card className={{ heigth: 400 }}>
        <CardBody>
          <p> Seleccione </p>
          <div className={classes.cardContainer}>
            {parner?.estado &&
              Object.keys(parner?.estado)?.map((item, _) => {
                const isEnabled = parner.estado[item] === 0
                return (
                  <Fragment key={item}>
                    <button
                      className={classes.bottomCard}
                      alt={`itl${_}${item}`}
                      type="button"
                      onClick={() =>
                        handleSelecterStep({
                          selected: { ...parner, name: item, isEnabled },
                        })
                      }
                    >
                      {item === 'discovery' && <PeopleIcon className={classes.iconCard} />}
                      {item === 'hoja_ruta' && <MapOutlined className={classes.iconCard} />}
                      {item === 'plan_detallado' && <AccountTreeOutlined className={classes.iconCard} />}
                      <p style={{ fontSize: '18px' }}>{item === 'hoja_ruta' ? 'HOJA DE RUTA' : item === 'plan_detallado' ? 'PLAN DETALLADO' : 'DESCUBRIR'}</p>

                    </button>
                  </Fragment>
                )
              })}
          </div>
        </CardBody>
      </Card>
    </section>
  )
}

export { GdcSearchBar }
